import React from "react";
import { createSvgIcon } from "@mui/material/utils";
import { Button, DropdownButton } from "@habitech/call-to-action";
import { Counter, WrapperButtons } from "./styles";
import Icon from "../Icon";
import { GridContainer, GridItem } from "../grids";
import { useCustomBar } from "./hooks/useCustomBar.hook";
import { StatusOptions } from "src/components/QualifyPropertyHabi/constants";
import { Tooltip } from "@mui/material";

const ExportIcon = createSvgIcon(
  <path d="M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z" />,
  "SaveAlt"
);

export const CustomToolbar = ({ apiRef }) => {
  const {
    getRowsSelected,
    handleExport,
    handleSendWhatsApp,
    handleSetSource,
    rowsSelected,
    loadingWhastApp,
    uniqueValuesCount,
    loading
  } = useCustomBar({ apiRef });

  return (
    <>
      <WrapperButtons>
        <GridContainer>
          <GridItem md={2} lg={3} data-id={"test_export_options_grid"}>
            <h5>{"Exportar y cambio de status:"}</h5>
            <DropdownButton
              dataId="test_export_options"
              listOptions={StatusOptions}
              defaultSelected={StatusOptions[0].value}
              originType="pcom"
              setValue={(value) => handleSetSource(value)}
              variant="white"
            />
            <Tooltip
              title={"Debe seleccional al menos un elemento de la tabla."}
              placement="top"
              disableHoverListener={uniqueValuesCount > 0}
            >
              <div>
                <Button
                  dataId="123"
                  originType="pcom"
                  iconLeft={<ExportIcon />}
                  loading={loading}
                  disabled={rowsSelected.length === 0}
                  onClick={() =>
                    handleExport({ getRowsToExport: getRowsSelected })
                  }
                >
                  Exportar y cambio de status
                </Button>
              </div>
            </Tooltip>
          </GridItem>
          <GridItem md={3} lg={3}>
            <h5>{"Envío de mensajes a WhatsApp:"}</h5>
            <Counter>
              <span>{`Se enviará mensaje a `}</span>
              <b>{uniqueValuesCount}</b>
              <span>{`${
                uniqueValuesCount > 1 || uniqueValuesCount === 0
                  ? " números de WhatsApp"
                  : " número de WhatsApp"
              }`}</span>
            </Counter>
            <Tooltip
              title={"Debe seleccional al menos un elemento de la tabla."}
              placement="top"
              disableHoverListener={uniqueValuesCount > 0}
            >
              <div>
                <Button
                  dataId="whatsapp"
                  originType="pcom"
                  loading={loadingWhastApp}
                  disabled={uniqueValuesCount === 0}
                  iconLeft={
                    <Icon className="whatsapp" icon={"pcom-icon-whatsapp"} />
                  }
                  onClick={() => handleSendWhatsApp()}
                >
                  {`Enviar ${
                    uniqueValuesCount > 1 ? "mensajes" : "mensaje"
                  } a WhatsApp`}
                </Button>
              </div>
            </Tooltip>
          </GridItem>
        </GridContainer>
      </WrapperButtons>
    </>
  );
};
